import styled from "styled-components";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { constructResponsiveImgUrl } from "../../../helpers";
import nondispo from "../../../images/imagenondisponible.png";
const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  transition: all 0.4s;
  > span {
    object-fit: cover;
    width: 100%;
    height: 100%;
    position: relative;
    top: 0;
    left: 0;
    cursor: pointer;
    overflow: hidden;
    transition: ease-in-out 4s;
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      position: relative;
      top: 0;
      left: 0;
      cursor: pointer;
      transition: ease-in-out 4s;
      overflow: hidden;
    }
  }
`;

function CardImg({ src, onClick, onMouseEnter }) {
  const imageSrc = src || nondispo;

  // Don't create srcset for fallback image
  if (!src) {
    return (
      <Wrapper>
        <LazyLoadImage
          effect="blur"
          onMouseEnter={onMouseEnter}
          onClick={onClick}
          src={nondispo}
          alt="Not available"
        />
      </Wrapper>
    );
  }

  // Generate responsive image URLs for API images
  const srcSet = `
    ${constructResponsiveImgUrl(imageSrc, 320, 75)} 320w,
    ${constructResponsiveImgUrl(imageSrc, 480, 75)} 480w,
    ${constructResponsiveImgUrl(imageSrc, 600, 75)} 600w,
    ${constructResponsiveImgUrl(imageSrc, 800, 75)} 800w
  `.trim();

  // Card sizes: mobile 210px, tablet ~300-400px, desktop ~470px max
  const sizes = `
    (max-width: 480px) 210px,
    (max-width: 768px) 300px,
    (max-width: 1024px) 400px,
    470px
  `.trim();

  return (
    <Wrapper>
      <LazyLoadImage
        effect="blur"
        onMouseEnter={onMouseEnter}
        onClick={onClick}
        src={constructResponsiveImgUrl(imageSrc, 600, 75)}
        srcSet={srcSet}
        sizes={sizes}
        alt="CardImg"
      />
    </Wrapper>
  );
}

export default CardImg;
